import { useAngularContext } from 'AngularContext';
import { type SiteMetadata } from './SiteMetadata.types';

export function useSiteMetadata() {
    const injector = useAngularContext();
    const SiteMetadata = injector.get<SiteMetadata>('SiteMetadata');
    return SiteMetadata;
}
